export default __webpack_public_path__ + "static/media/dashboardicon.4d8f6ebb.svg";